import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import { markClassicScrollbars } from '@skynet/sky-scrollable-area';
import './instrument';
import { App } from './app';

markClassicScrollbars();

const rootDiv = document.getElementById('root')!;

if (!rootDiv) {
  throw new Error("The element #root wasn't found");
}

createRoot(rootDiv).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
